import AdminLiveSupportPage from '../../../components/admin/support/AdminLiveSupportPage'

export default function Support() {
  return <AdminLiveSupportPage />
}
